export default function About() {
  return (
    <section id="about" className="relative min-h-screen flex items-center py-20">
      <div className="absolute top-1/2 left-0 -translate-y-1/2 w-[500px] h-[500px] bg-[#f15700] opacity-[0.05] blur-[150px] rounded-full pointer-events-none"></div>
      <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-[#f15700] opacity-[0.03] blur-[120px] rounded-full pointer-events-none"></div>

      <div className="container max-w-7xl mx-auto px-6 lg:px-12 relative z-10 w-full">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="animate__animated custom-delay-2">
            <h2 className="text-5xl md:text-6xl font-bold text-white mb-6">
              About <span className="text-[#f15700]">me</span>
            </h2>
            <div className="w-24 h-1.5 bg-[#f15700] rounded-full mb-10"></div>
            <div className="p-10 rounded-3xl bg-white/[0.03] border border-white/10 backdrop-blur-sm shadow-2xl">
              <p className="text-gray-300 text-xl leading-relaxed mb-8">
                I am a Full Stack Developer with a background of over 2 years in the field. My passion lies in crafting robust and efficient web applications that not only look great but also provide exceptional user experiences.
              </p>
              <p className="text-gray-400 text-lg leading-relaxed">
                My journey as a developer has equipped me with a diverse skill set, enabling me to handle both frontend and backend development seamlessly. I thrive on challenges and am dedicated to staying updated with the latest technologies and industry trends.
              </p>
            </div>
          </div>
          
          <div className="animate__animated custom-delay-3 p-10 rounded-3xl bg-gradient-to-br from-white/[0.05] to-transparent border border-white/5 backdrop-blur-sm self-stretch flex flex-col justify-center">
            <h3 className="text-3xl font-bold text-white mb-8">My Approach</h3>
            <ul className="space-y-8">
              <li className="flex items-start gap-5">
                <div className="flex-shrink-0 w-12 h-12 rounded-full bg-[#f15700]/20 flex items-center justify-center text-[#f15700]">
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path></svg>
                </div>
                <div>
                  <h4 className="text-white font-semibold text-xl">Performance First</h4>
                  <p className="text-gray-400 text-base mt-2 leading-relaxed">Building fast, optimized applications that scale effortlessly.</p>
                </div>
              </li>
              <li className="flex items-start gap-5">
                <div className="flex-shrink-0 w-12 h-12 rounded-full bg-[#f15700]/20 flex items-center justify-center text-[#f15700]">
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path></svg>
                </div>
                <div>
                  <h4 className="text-white font-semibold text-xl">Pixel Perfect UI</h4>
                  <p className="text-gray-400 text-base mt-2 leading-relaxed">Creating beautiful, responsive interfaces with modern frameworks.</p>
                </div>
              </li>
              <li className="flex items-start gap-5">
                <div className="flex-shrink-0 w-12 h-12 rounded-full bg-[#f15700]/20 flex items-center justify-center text-[#f15700]">
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"></path></svg>
                </div>
                <div>
                  <h4 className="text-white font-semibold text-xl">Clean Code</h4>
                  <p className="text-gray-400 text-base mt-2 leading-relaxed">Writing maintainable, scalable, and documented architecture.</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
